import React from "react";
import { useDisclosure } from "../hooks";
import { Tooltip } from "../tooltip";
import { cn } from "../utils";
import { LightboxFile } from "./lightbox-file";
import { LightboxImage } from "./lightbox-image";
import { LightboxModal } from "./lightbox-modal";
import type { ItemProps } from "./shared";

export function Item({ children, ...props }: ItemProps) {
	/** Context */
	const isImage = props.contentType.startsWith("image/");
	const _isVideo = props.contentType.startsWith("video/");

	/** Hooks */
	const disclosure = useDisclosure();

	/** Computed */
	const trigger = (
		<div
			className={cn(
				"cursor-pointer active:opacity-90",
				children ? "w-full" : "card p-0 overflow-hidden",
				props.className,
			)}
			onClick={disclosure.onOpen}
			data-lightbox-item="true"
			data-src={props.src}
			data-height={props.height}
			data-width={props.width}
			data-content-type={props.contentType}
			data-item-id={props.id}
			data-file-name={props.fileName}
		>
			{children ?? (isImage ? <LightboxImage {...props} /> : <LightboxFile {...props} />)}
		</div>
	);

	/** Render */
	return (
		<React.Fragment>
			{children ? trigger : <Tooltip label={props.fileName}>{trigger}</Tooltip>}
			{disclosure.isOpen && (
				<LightboxModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					itemId={props.id}
					getAnnotations={props.getAnnotations}
					onSaveAnnotations={props.onSaveAnnotations}
				/>
			)}
		</React.Fragment>
	);
}
